import { format } from 'date-fns';
import type {
  Filters,
} from 'hooks/store/invoices/use-invoices-tracking-search-params';
import type { FormSchema } from './form-schema';

const f = (date: Date) => {
  return format(date, 'yyyy-MM-dd');
};

export const createFilters = (formData: FormSchema): Filters => {
  const { emissionDate, deadlineDate, deliveryDate, ...rest } = formData;

  return {
    ...rest,
    ...(emissionDate?.from && { emissionDateFrom: f(emissionDate.from) }),
    ...(emissionDate?.to && { emissionDateTo: f(emissionDate.to) }),
    ...(deadlineDate && { deadlineDate: f(deadlineDate) }),
    ...(deliveryDate && { deliveryDate: f(deliveryDate) }),
  };
};

export const createReportParams = (formData: FormSchema) => {
  const filters = createFilters(formData);
  Object.entries(filters).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      // @ts-ignore
      filters[key] = value.toString();
    }
  });

  Object.entries(filters).forEach(([key, value]) => {
    if (!value) {
      // @ts-ignore
      delete filters[key];
    }
  });

  return filters;
};